import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";
import { getConsent, setConsent, track } from "@/lib/tracking";
import { useTour } from "@/components/tour/TourProvider";

const T = {
  en: { title: "Cookies on GrantVerify", body: "We use essential cookies to run the site. With your OK, we also use advertising cookies (Meta, Google, LinkedIn and Paramount) to measure our ads. Nothing is tracked unless you accept.", accept: "Accept", reject: "Reject", more: "Privacy Policy" },
  es: { title: "Cookies en GrantVerify", body: "Usamos cookies esenciales para que el sitio funcione. Con su permiso, también usamos cookies publicitarias (Meta, Google, LinkedIn y Paramount) para medir nuestros anuncios. No se rastrea nada a menos que acepte.", accept: "Aceptar", reject: "Rechazar", more: "Política de privacidad" },
};

export const openCookieSettings = () => window.dispatchEvent(new Event("gv-cookie-settings"));

export function CookieBanner() {
  const loc = useLocation();
  const [open, setOpen] = useState(!getConsent());
  const lang = useTour().lang === "es" ? "es" : "en";
  const t = T[lang];
  useEffect(() => { track("PageView"); }, [loc.pathname]);
  useEffect(() => { const h = () => setOpen(true); window.addEventListener("gv-cookie-settings", h); return () => window.removeEventListener("gv-cookie-settings", h); }, []);
  if (!open) return null;
  const choose = (v) => { setConsent(v); setOpen(false); };
  return (
    <div className="fixed bottom-2 left-2 right-2 sm:bottom-4 sm:left-auto sm:right-6 sm:max-w-md z-[9999] pointer-events-auto bg-[#0b1730] text-white rounded-xl border border-slate-700 shadow-2xl p-3 sm:p-5" role="dialog" aria-live="polite" data-testid="cookie-banner">
      <div className="flex items-center gap-2 font-semibold text-sm sm:text-base"><Cookie className="h-4 w-4 text-emerald-400" />{t.title}</div>
      <p className="text-xs sm:text-sm text-slate-300 mt-1 sm:mt-2">{t.body} <Link to="/privacy" className="underline text-emerald-300" data-testid="cookie-banner-privacy-link">{t.more}</Link></p>
      <div className="flex gap-2 mt-2 sm:mt-4">
        <button onClick={() => choose("rejected")} className="flex-1 h-10 rounded-md border border-slate-500 text-sm hover:bg-white/10 transition-colors" data-testid="cookie-reject-button">{t.reject}</button>
        <button onClick={() => choose("accepted")} className="flex-1 h-10 rounded-md bg-emerald-600 hover:bg-emerald-500 text-sm font-semibold transition-colors" data-testid="cookie-accept-button">{t.accept}</button>
      </div>
    </div>
  );
}
